<template>
    <div>
        <h1>Board</h1>
    </div>
</template>

<script>
export default {
    name: "Board"
};
</script>

<style scoped></style>
